import { useEffect, useState } from "react";

const navLinks = [
  { label: "格式分类", href: "#formats" },
  { label: "热门作品", href: "#trending" },
  { label: "编辑精选", href: "#picks" },
  { label: "主题浏览", href: "#themes" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-6 lg:px-10">
        <a
          href="#home"
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="同人志典藏站首页"
        >
          <span
            className={`grid h-9 w-9 items-center justify-center rounded-md text-lg ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-book-2-fill"></i>
          </span>
          <span
            className={`font-label text-lg tracking-wide ${
              scrolled ? "text-foreground-950" : "text-foreground-950"
            }`}
          >
            同人志典藏站
          </span>
        </a>

        <ul className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`text-sm whitespace-nowrap transition-colors ${
                  scrolled ? "text-foreground-700 hover:text-primary-600" : "text-foreground-800 hover:text-primary-600"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#trending"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 sm:inline-block"
          >
            立即阅读
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className="grid h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 lg:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2 text-sm text-foreground-800 hover:bg-background-100"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}